module.exports = __webpack_public_path__ + "img/earnUp.1521db24.svg";